const NovedadesTabItem = (
    props: React.SVGProps<SVGSVGElement>
): React.ReactElement => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            {...props}
        >
            <path
                d="M6.72308 20.72C6.51881 20.4342 6.27785 20.0963 6.01264 19.7239C4.28997 17.3046 1.54414 13.4284 1.18352 12.9239C1.17334 12.9095 1.16797 12.8925 1.16797 12.8749V0.584946C1.16797 0.537943 1.20585 0.5 1.25278 0.5H8.74445C8.77272 0.5 8.79901 0.514158 8.81485 0.537376L15.7993 10.8889C15.8008 10.8909 15.8022 10.8928 15.8036 10.8948C15.8695 10.9761 18.5167 13.639 17.1288 14.1453C15.7656 14.6427 16.3424 12.4629 16.5383 10.5845C16.5502 10.4718 16.5561 10.3583 16.5561 10.245L16.5912 0.584663C16.5912 0.537943 16.6294 0.5 16.676 0.5H24.0832C24.1301 0.5 24.168 0.537943 24.168 0.584946V23.3179C24.168 23.4184 24.0865 23.5 23.9862 23.5H16.6356C16.6082 23.5 16.5822 23.4866 16.5663 23.464L8.89881 12.6263C8.85103 12.5586 8.74474 12.5926 8.74474 12.6756V23.2355C8.74474 23.3182 8.639 23.3521 8.59094 23.285L8.57596 23.2641C8.57115 23.2573 6.7276 20.7265 6.72308 20.72Z"
                stroke="#686058"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
        </svg>
    )
}

export default NovedadesTabItem
